import { createContext } from 'react';

import {
  TicketCategory,
  TicketTypeConfig,
} from '@totem/components/ticketing/ticketing';

interface TicketConfigurationContext {
  ticketTypes: TicketTypeConfig[];
  categories: TicketCategory[];
  filteredCategories: TicketCategory[];
}

export default createContext<TicketConfigurationContext>({
  ticketTypes: [],
  categories: [],
  filteredCategories: [],
});
